import { UpdateProductQuantityFromMyWishlistInput } from '@spa/generated/graphql/graphql';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiUpdateProductQuantityFromMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly input: UpdateProductQuantityFromMyWishlistInput;
  readonly parentActionId: number;
}

export const apiUpdateProductQuantityFromMyWishlistRequestedType =
  'api/wishlist/updateProductQuantityFromMyWishlist--requested';
export const apiUpdateProductQuantityFromMyWishlistRequested = createAction<
  ApiUpdateProductQuantityFromMyWishlistRequestedPayload,
  typeof apiUpdateProductQuantityFromMyWishlistRequestedType
>(apiUpdateProductQuantityFromMyWishlistRequestedType);
export type ApiUpdateProductQuantityFromMyWishlistRequestedAction = ReturnType<
  typeof apiUpdateProductQuantityFromMyWishlistRequested
>;

export interface ApiUpdateProductQuantityFromMyWishlistSucceededPayload {
  readonly input: UpdateProductQuantityFromMyWishlistInput;
  readonly parentActionId: number;
  readonly requestedActionId: number;
}

export const apiUpdateProductQuantityFromMyWishlistSucceededType =
  'api/wishlist/updateProductQuantityFromMyWishlist--succeeded';
export const apiUpdateProductQuantityFromMyWishlistSucceeded = createAction<
  ApiUpdateProductQuantityFromMyWishlistSucceededPayload,
  typeof apiUpdateProductQuantityFromMyWishlistSucceededType
>(apiUpdateProductQuantityFromMyWishlistSucceededType);
export type ApiUpdateProductQuantityFromMyWishlistSucceededAction = ReturnType<
  typeof apiUpdateProductQuantityFromMyWishlistSucceeded
>;

export interface ApiUpdateProductQuantityFromMyWishlistFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly error: WishlistError;
}

export const apiUpdateProductQuantityFromMyWishlistFailedType =
  'api/wishlist/updateProductQuantityFromMyWishlist--failed';
export const apiUpdateProductQuantityFromMyWishlistFailed = createAction<
  ApiUpdateProductQuantityFromMyWishlistFailedPayload,
  typeof apiUpdateProductQuantityFromMyWishlistFailedType
>(apiUpdateProductQuantityFromMyWishlistFailedType);
export type ApiUpdateProductQuantityFromMyWishlistFailedAction = ReturnType<
  typeof apiUpdateProductQuantityFromMyWishlistFailed
>;
